var _line, _line2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDerivatieDinConductor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 81,
    viewBox: "0 0 77 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 40.5,
    x2: 77,
    y2: 40.5,
    stroke: "black",
    strokeWidth: 3.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    y1: 81,
    x2: 38.5,
    y2: 38,
    stroke: "black",
    strokeWidth: 3.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 41,
    r: 6,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerivatieDinConductor);
export default __webpack_public_path__ + "static/media/derivatie_din_conductor.f41533f5995a5781aa3693ba4e01fcd4.svg";
export { ForwardRef as ReactComponent };